import { render, staticRenderFns } from "./TopSources.vue?vue&type=template&id=53a34830"
import script from "./TopSources.vue?vue&type=script&lang=js"
export * from "./TopSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports